var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 21 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.5,11.4c3.2,0.1,5.8-2.4,5.9-5.5c0.1-3.2-2.4-5.8-5.5-5.9S5,2.4,4.9,5.5c0,0.1,0,0.1,0,0.2   C4.9,8.8,7.4,11.4,10.5,11.4z M10.5,1.5c2.3-0.1,4.3,1.8,4.3,4.1c0.1,2.3-1.8,4.3-4.1,4.3S6.5,8.1,6.4,5.8c0,0,0-0.1,0-0.1   C6.4,3.4,8.2,1.5,10.5,1.5L10.5,1.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.7,20h19.5c0.4,0,0.7-0.3,0.7-0.7c0,0,0,0,0,0c0-3.9-3.1-7.1-7.1-7.2H7c-3.9,0-7.1,3.2-7,7.2   C0,19.7,0.3,20,0.7,20C0.7,20,0.7,20,0.7,20z M7.1,13.6H14c2.8,0,5.2,2.1,5.5,4.9H1.5C1.9,15.7,4.2,13.6,7.1,13.6L7.1,13.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfile);
export default __webpack_public_path__ + "static/media/icon-profile.2871bb2be47b1581cc9f74e80c5c16c1.svg";
export { ForwardRef as ReactComponent };